import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { config } from '@/config';
// Firebase config is a public identifier — not a secret.
// Security is enforced by Firebase Security Rules and backend JWT validation.
// Google's own quickstart docs show these values hardcoded in source.
// Keys are selected at build time via VITE_APP_ENV.
const firebaseConfigs = {
    dev: {
        apiKey: 'AIzaSyDSNjUoivi3OW9HP5bnSn9XZzxyZC8FLAI',
        authDomain: 'acie-dev.firebaseapp.com',
        projectId: 'acie-dev',
        appId: '1:275792759899:web:e06751eeecf881e2b2837e',
    },
    stg: {
        apiKey: 'AIzaSyDSNjUoivi3OW9HP5bnSn9XZzxyZC8FLAI',
        authDomain: 'acie-dev.firebaseapp.com',
        projectId: 'acie-dev',
        appId: '1:275792759899:web:e06751eeecf881e2b2837e',
    },
    prod: {
        apiKey: 'AIzaSyDSNjUoivi3OW9HP5bnSn9XZzxyZC8FLAI',
        authDomain: 'acie-dev.firebaseapp.com',
        projectId: 'acie-dev',
        appId: '1:275792759899:web:e06751eeecf881e2b2837e',
    },
};
const firebaseApp = initializeApp(firebaseConfigs[config.appEnv]);
export const firebaseAuth = getAuth(firebaseApp);
